import { Icon } from '@iconify/react';
import { startOfMonth } from 'date-fns';
import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { CommonContext, UserContext } from '../../contexts';
import { getReportMxData } from '../../data/mysql';
import { useMonthlyReportStore } from '../../store/reportStore';
import MonthNavigator from './screen/MonthNavigator';
import ReportBaseCreator from './screen/ReportBaseCreator';
import ReportBaseInfo from './screen/ReportBaseInfo';
import WorkCalendar from './screen/WorkCalendar';
import ActivitiesCountSum from './screen/ActivitiesCountSum';
import ActivitiesCount from './screen/ActivitiesCount';
import SeekerCount from './screen/SeekerCount';
import LostCount from './screen/LostCount';
import BooksCount from './screen/BooksCount';
import MembersCount from './screen/MembersCount';
import AttendanceCount from './screen/AttendanceCount';
import AddSeekers from './screen/AddSeekers';
import AddRequest from './screen/AddRequest';
import TransportationSelect from './screen/TransportationSelect';
import { Vision2028 } from './screen/vision2028/Vision2028';

const MonthlyReport = () => {
  const { categories } = useContext(CommonContext);
  const { user } = useContext(UserContext);
  const { pathname } = useLocation();
  const { reportMxData, selectedMonth, setReportMxData } = useMonthlyReportStore();

  useEffect(() => {
    if (!user.id) return; // 로그인 유무 체크

    getReportMxData({
      userId: user.id, //
      dt: Math.floor(startOfMonth(selectedMonth).getTime() / 1000), // 그 달의 첫날을 Unix Time으로 보낸다
    }).then(setReportMxData);
  }, [user.id, selectedMonth]);

  return (
    <div id="primary" className="content-area">
      {/* <!--s:#content --> */}
      <div id="content" className="site-content">
        <article>
          <div>
            <div className="title-inner">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <img src="/common/images/title.png" alt="" />
                  <h1>{categories.find((category) => category.categoryCode === pathname.split('/')[4])?.categoryName}</h1>
                </div>
                <div
                  style={{
                    display: 'flex', //
                    flexDirection: 'column',
                    alignItems: 'center',
                    cursor: 'pointer',
                  }}
                  onClick={() => window.open('https://youtu.be/LehiNxGCBVs')}
                >
                  <Icon icon="entypo-social:youtube-with-circle" width={40} color={'#888'} />
                  <span style={{ fontFamily: '기본체', fontSize: '0.8em', color: '#888' }}>사용방법</span>
                </div>
              </div>
            </div>
            <div style={{ height: 20 }}></div>
            <div style={{ clear: 'both' }}></div>
            <div className="title_subpage_solid_1"></div>

            <div className="container-fluid">
              <MonthNavigator />

              {!reportMxData ? (
                <ReportBaseCreator />
              ) : (
                <>
                  <ReportBaseInfo />
                  <Vision2028 /> {/* 3000제자, 1000사역팀 */}
                  <WorkCalendar /> {/* 일정 현황 */}
                  <ActivitiesCountSum /> {/* 활동 현황 */}
                  <ActivitiesCount /> {/* 활동 현황 */}
                  <SeekerCount /> {/* 구도자 */}
                  <LostCount /> {/* 잃은양 */}
                  <BooksCount /> {/* 정기간행물 */}
                  <MembersCount /> {/* 교인 현황 */}
                  <AttendanceCount /> {/* 예배 평균 출석자 수 */}
                  <AddSeekers /> {/* 구도자 명단 */}
                  <AddRequest /> {/* 통신란 */}
                  <TransportationSelect /> {/* 기타 */}
                </>
              )}
            </div>
          </div>
          {/* <!-- .entry-content --> */}
        </article>
      </div>
      {/* <!--//e: #content --> */}
    </div>
  );
};

export default MonthlyReport;
